import { createTheme } from '@mui/material/styles';

declare module '@mui/material/Typography' {
  interface TypographyPropsVariantOverrides {
    h4Onboarding: true;
  }
}

// So we can use these values in our final custom theme
const baseTheme = createTheme({
  mixins: {
    toolbar: {
      minHeight: 45,
    },
  },
  palette: {
    primary: {
      main: '#2b2e32',
      dark: '#7b1fa2',
      light: '#ba68b8',
      contrastText: '#ffffff',
    },
    secondary: {
      main: '#ffc659',
      contrastText: '#151522',
      dark: '#fab737',
    },
    error: {
      main: '#ff604f',
    },
  },
});

const theme = createTheme(baseTheme, {
  typography: {
    h4Onboarding: {
      ...baseTheme.typography.h4,
      lineHeight: '94%',
      fontWeight: 'bold',
      marginTop: baseTheme.spacing(4),
    },
  },
  components: {
    MuiButton: {
      styleOverrides: {
        containedPrimary: {
          backgroundColor: baseTheme.palette.secondary.main,
          color: baseTheme.palette.secondary.contrastText,
          '&:hover': {
            backgroundColor: baseTheme.palette.secondary.dark,
            color: baseTheme.palette.secondary.contrastText,
          },
        },
        sizeLarge: {
          minHeight: '52px',
        },
      },
    },
  },
});

export default theme;
